import React from 'react';
import { RuleResultSpecBarcode } from '../types';

interface SpecCheckDetailsBarcodeProps {
    ruleResult: RuleResultSpecBarcode;
}

const SpecCheckDetailsBarcode: React.FC<SpecCheckDetailsBarcodeProps> = ({
    ruleResult,
}) => {
    if (ruleResult.output_data.detected_barcodes.length === 0) {
        return (
            <div style={{ fontStyle: 'italic', color: '#666' }}>
                No barcodes detected
            </div>
        );
    }

    return (
        <table className="spec-check-details-text-changes-new">
            <thead>
                <tr></tr>
            </thead>
            <tbody>
                {ruleResult.output_data.detected_barcodes.map(
                    (barcode, index) => (
                        <tr key={index}>
                            <td>{barcode.type}</td>
                            <td style={{ fontFamily: 'monospace' }}>
                                {barcode.data}
                            </td>
                        </tr>
                    ),
                )}
            </tbody>
        </table>
    );
};

export default SpecCheckDetailsBarcode;

